import { Text, TextProps } from "@mantine/core";

interface GradientTextProps extends TextProps {
  children: React.ReactNode;
}

export function GradientText({ children, ...props }: GradientTextProps) {
  return (
    <Text
      span
      inherit
      fw={700}
      style={{
        background:
          "linear-gradient(45deg, var(--mantine-color-orange-filled) 0%, var(--mantine-color-red-filled) 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
      }}
      {...props}
    >
      {children}
    </Text>
  );
}
